export default __webpack_public_path__ + "static/media/odvz_depto_legal_color.66e69bd5.png";